import { render, staticRenderFns } from "./ResidentPage.vue?vue&type=template&id=dd2336c4&scoped=true&"
import script from "./ResidentPage.vue?vue&type=script&lang=ts&"
export * from "./ResidentPage.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentPage.vue?vue&type=style&index=0&id=dd2336c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2336c4",
  null
  
)

export default component.exports